import { BaseContainerModel } from "../base-container.model";
import { bl_fi_mst_comp_entity_purchase_credit_terms_RowCLass } from "../../dbschema/bl_fi_mst_comp_entity_purchase_credit_terms.model";

export class CompanyEntityPurchaseCreditTermsContainerModel extends BaseContainerModel {
  bl_fi_mst_comp_entity_purchase_credit_terms: bl_fi_mst_comp_entity_purchase_credit_terms_RowCLass =
    new bl_fi_mst_comp_entity_purchase_credit_terms_RowCLass();
}
